import React from "react";
import SignalIcon from "../SignalIcon";
import { AccountLogo } from "../AccountLogo";
import ContactAvatar from "Pages/Dashboard/contacts/ContactAvatar";
import { authorLine, confidenceText, displayName } from "./customSignalMeta";
import { timeAgo, trimText } from "../signalMeta";

/** The quotes behind a custom signal: what was said, who said it, when, and a link to the post. */
export const Evidence = ({ evidence, max = 2 }) => {
  const list = (Array.isArray(evidence) ? evidence : []).slice(0, max);
  if (!list.length) return null;
  return (
    <div className="cs-evid">
      {list.map((ev, i) => (
        <blockquote key={`${ev.url || ""}-${i}`} className="cs-quote">
          <p>“{trimText(ev.text, 260)}”</p>
          <footer>
            {authorLine(ev) && <span>{authorLine(ev)}</span>}
            {ev.date && <span>{timeAgo(ev.date)}</span>}
            {ev.url && (
              <a href={ev.url} target="_blank" rel="noopener noreferrer">
                View post <SignalIcon id="external" size={12} />
              </a>
            )}
          </footer>
        </blockquote>
      ))}
    </div>
  );
};

/** One preview match, laid out like a feed row: the record, why it fired and the quotes. */
export const CustomMatch = ({ match }) => {
  const m = match || {};
  const isContact = m.recordType === "contact";
  const strength = confidenceText(m.confidence);
  const name = displayName(m.recordName, m.recordDomain) || "A record";
  return (
    <div className="cs-match">
      <span className="sg-frow__av">
        {isContact ? <ContactAvatar name={name} /> : <AccountLogo domain={m.recordDomain} name={name} />}
      </span>
      <div className="sg-grow">
        <div className="cs-match__head">
          <b>{name}</b>
          {strength && <span className="sg-pill sg-pill--live">{strength}</span>}
        </div>
        {m.why && <div className="cs-match__why">{m.why}</div>}
        <Evidence evidence={m.evidence} />
      </div>
    </div>
  );
};
